import { render, staticRenderFns } from "./PartialStateBuyboxFeature.vue?vue&type=template&id=3abd7beb&"
import script from "./PartialStateBuyboxFeature.vue?vue&type=script&lang=ts&"
export * from "./PartialStateBuyboxFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PartialStateBuyboxFeature.vue"
export default component.exports